import dayjs from "dayjs"
import { insert } from "underscore.string"

export const normalizeString = (str) => {
	if (typeof str !== "string") return ""
	return str
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
}

export const capitalize = (s) => {
	if (typeof s !== "string") return ""
	return s.charAt(0).toUpperCase() + s.slice(1)
}
export const formulaTokenToReadableDisplay = (formula) => {
	const regex = /\[(!?\w+):([^\]]*?):([^\]]+?)\]/g
	let match
	let updatedDisplay = formula
	while ((match = regex.exec(formula)) !== null) {
		const token = {
			name: `${match[1]}`,
			value: match[2],
			label: match[3],
		}

		// Substitui o token completo pelo `name` no display
		updatedDisplay = updatedDisplay.replace(match[0], token.name)
	}
	return updatedDisplay
}
export async function labelFetcher(label, controller) {
	if (label.value) return label
	let fetchedLabel = await controller(label.context).read(
		label.context,
		label.id
	)
	label = { ...label, value: fetchedLabel[label.field] }
	return label
}
export const subId = (s) => {
	return s.replace("Id", "")
}
export const gentlyReadableFormula = (formula) => {
	const regex = /\[([^\]]+?)\]/g

	return formula.replace(regex, (match, content) => {
		// Verificar se o conteúdo dentro dos colchetes é maior que 2 caracteres
		if (content.length > 2) {
			return `[${content.slice(0, 2)}]`
		}
		// Retornar o conteúdo original se não for maior que 2 caracteres
		return match
	})
}
export const insertOn = (string, index, valueToInsert) => {
	const result = insert(string, index - 1, valueToInsert)
	return result
}
export const normalizeKey = (s) => {
	if (typeof s !== "string") return s
	let separado = s.replace(/(?=([A-Z]))/, " ")
	return capitalize(separado)
}

export const addApiKey = (url, key) => {
	return `${url}${key}`
}

export const formatIsoDate = (date) => {
	if (date) {
		let day = dayjs(date).format("YYYY-MM-DDTHH:mm")

		return day
	}
}

export const formulaFormater = (formula) => {
	let objFormulaMapping = {}
	const regex = /\[([]\d+)\]/g
	const valuesToReplace = [...formula.matchAll(regex)]
	if (valuesToReplace.length > 0) {
		valuesToReplace.forEach((v, i) => {
			if (!objFormulaMapping[v[1]]) objFormulaMapping[v[1]] = null
		})
	}

	return objFormulaMapping
}
export const formulaDataExtractor = (formula) => {
	const regex = /\[([^\]]+)\]/g
	const formulaDatas = []
	const valuesToReplace = formula.matchAll(regex)
	for (let v of valuesToReplace) {
		let formulaData = v[1].split(":")
		formulaDatas.push(formulaData)
	}
	return formulaDatas
}

export const FormatDate = (data) => {
	const dataTokens = String(data).split("-")
	return dataTokens[2] + "-" + dataTokens[1] + "-" + dataTokens[0]
}

export const OnlyDate = (data, separator) => {
	let sep = separator ? separator : "-"
	const inverseDate = String(data).split("T")
	const onlyDate = inverseDate[0].split("-")
	return `${onlyDate[2] + sep + onlyDate[1] + sep + onlyDate[0]}`
}
export const toUpperCaseNoSpace = (texto) => {
	return texto.replace(/\s/g, "").toUpperCase()
}

export const DateAndTime = (data, separator) => {
	let sep = separator ? separator : "-"
	data = formatIsoDate(data)
	if (data) {
		const inverseDate = String(data).split("T")
		const onlyDate = inverseDate[0].split("-")
		let time = inverseDate[1].split("-")[0].split(":")
		time = `${time[0]}:${time[1]}`
		return `${onlyDate[2] + sep + onlyDate[1] + sep + onlyDate[0]} ${time}`
	} else {
		return ""
	}
}
export const capitalizeFirstLetterOfEachWord = (input) => {
	return input
		.split(" ")
		.map((word) => {
			return word.charAt(0).toUpperCase() + word.slice(1)
		})
		.join(" ")
}
export const conditionalTimeTypesPluralize = (condition, string) => {
	string = capitalizeFirstLetterOfEachWord(string)
	if (condition) {
		if (string === "Mes") return `${string}es`
		else return `${string}s`
	} else return string
}

export const calculateTimeBetweenTowIsoStringDate = (
	iniciadoEm,
	finalizadoEm,
	factor,
	scale
) => {
	const ini = new Date(iniciadoEm)
	const fini = new Date(finalizadoEm)
	let intervalo = fini.getTime() - ini.getTime()
	return `${(intervalo / factor).toFixed(2)} ${scale}`
}
export const onlyTime = (data) => {
	const inverseDate = String(data).split("T")
	const time = inverseDate[1].split(".")
	return time[0]
}
/**
 *
 * @param {*} path caminho do app SGP
 * @returns /ComponenteForm => Componente
 */
export const pathToHeader = (path) => {
	if (path == "/Login") return ""
	let espacar = path
		.replace(/([A-Z])/g, " $1")
		.trim()
		.replace(/\//g, "")
	let resultado = espacar.charAt(0).toUpperCase() + espacar.slice(1)

	let endsWithForm = resultado.endsWith("Form" || "form")

	if (endsWithForm) {
		return resultado.substring(0, resultado.length - 4)
	} else return resultado
}
export const buildPageTitle = (path, notificationCount) => {
	const pageTitle = pathToHeader(path);
	if (notificationCount > 0) {
		return `${pageTitle} | (${notificationCount > 99 ? "99+" : notificationCount}) Notificaçãoes não lidas`;
	} else {
		return pageTitle;
	}
};
/**@param {string} excelDate */
export const parseExcelDateToDate = (excelDate) => {
	let dateTimeTokens = Array.isArray(excelDate)
		? excelDate[0].split(" ")
		: excelDate.split(" ")
	let data = dateTimeTokens[0]
	let tempo = dateTimeTokens[1]
	let dataTokens = data.split("/")
	let tempoTokens = tempo.split(":")
	let dataTranformada = new Date(
		dataTokens[2],
		dataTokens[1] - 1,
		dataTokens[0],
		tempoTokens[0],
		tempoTokens[1],
		tempoTokens[2]
	)
	return dataTranformada
}

export const dUtc = (date) => {
	return DateAndTime()
}
export const especificacaoDisplay = (espec) => {
	let texto = ""
	espec.limitesDeControle.forEach((lc, index) => {
		texto = texto.concat(`${lc.nome} ${lc.valor}`)
		if (index != espec.limitesDeControle.length - 1)
			texto = texto.concat(" - ")
	})
	return texto
}
export const transformarObjetoParaUrl = (obj) => {
	return encodeURIComponent(JSON.stringify(obj))
}
export function removeAcentos(str) {
	const acentuadas = "áàãâäéêíóòõôúüç"
	const semAcento = "aaaaaeeiooouuc"

	return str
		.split("")
		.map((char) => {
			const index = acentuadas.indexOf(char)
			return index !== -1 ? semAcento[index] : char
		})
		.join("")
}
/**
 * Gera a URL para acessar ou baixar a imagem do backend.
 * @param {string} key - Caminho ou identificador do arquivo no backend.
 * @param {boolean} [download=false] - Indica se a URL deve forçar o download.
 * @returns {string} URL que bate no endpoint /getImage com as queries adequadas.
 */
export function buildImageURL(key) {
	const base = "getImage" // ou "/api/getImage" dependendo da sua rota
	const params = new URLSearchParams({ key })

	return `${base}?${params.toString()}`
}
